import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

class Financeiro extends React.Component{
  constructor (props){
    super(props);
  }

  render() {
    return (
      <div className="page-financeiro" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Financeiro"></MainTitle>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Financeiro;



// WEBPACK FOOTER //
// ./src/classes/financeiro/Financeiro.js